import apiClient from "./axios";

export const getOverview = async (params?: { tracking_numbers?: string }) =>
  apiClient.get("/dashboard/overview", { params });

export const getRangeStats = async (params: {
  start_date: string;
  end_date: string;
  tracking_numbers?: string;
}) => apiClient.get("/dashboard/range-stats", { params });

export const getTrackingDetails = async (params: {
  start_date: string;
  end_date: string;
  tracking_numbers?: string;
}) => apiClient.get("/dashboard/tracking-details", { params });

export const getRagStats = async () => apiClient.get("/dashboard/rag-stats");
export const getAgentStats = async () =>
  apiClient.get("/dashboard/agent-stats");
export const getErrors = async (params?: Record<string, unknown>) =>
  apiClient.get("/dashboard/errors", { params });
